import { closest } from '@utils/domUtils';

export default function pasteDefaultPrivacy(action) {
  const defaultPrivacy = document.querySelector('[data-prop="defaultPrivacy"]');
  const textarea = document.querySelector('[name="privacyNotice"]');
  const wysiwyg = closest(textarea, '.Wysiwyg');

  if (!(defaultPrivacy && textarea && wysiwyg && wysiwyg.editor)) {
    return;
  }

  textarea.value = defaultPrivacy.innerHTML;
  wysiwyg.editor.setData(defaultPrivacy.innerHTML);
}
